<template>
  <div>
    <div v-if="!loading">
      <transition name="modal">
        <delete-modal
          v-if="showDeleteModal"
          @close="closeDeleteModal"
          @confirmDelete="deletePaymentMethod"
        ></delete-modal>
      </transition>

      <transition name="modal">
        <payment-method-modal
          v-if="showPaymentMethodModal"
          @close="showPaymentMethodModal = false"
          @paymentMethodAdded="
            showPaymentMethodModal = false;
            loadPaymentMethods();
          "
        ></payment-method-modal>
      </transition>

      <div class="flex flex-col">
        <div class="card">
          <card-header :title="'Franquicia #' + user.franchise_user.franchise.id">
          </card-header>

          <div class="detail-grid">
            <detail-field label="Nombre" :value="user.franchise_user.franchise.name" />
            <detail-field label="Franquiciatario" :value="user.franchise_user.franchise.franchisee_name + ' ' + user.franchise_user.franchise.franchisee_last_name" />
            <detail-field label="Fecha de creación" :value="formatDatetime(user.franchise_user.franchise.created_at)" />
            <detail-field label="Fecha de última actualización" :value="formatDatetime(user.franchise_user.franchise.updated_at)" />
            <detail-field label="Fondo de Publicidad" :value="integerToCurrency(user.franchise_user.franchise.advertisement_fund)" :prominent="true" />
          </div>
        </div>

        <h2 class="mt-6">Métodos de pago</h2>

        <button
          class="primary-button mt-2 w-fit mx-0"
          @click.prevent="showPaymentMethodModal = true"
        >
          Agregar Método de Pago
        </button>

        <div class="flex flex-wrap">
          <div
            v-for="paymentMethod in paymentMethods"
            :key="paymentMethod.id"
            class="card w-full sm:w-56 mr-4 mt-6"
          >
            <div class="flex justify-between items-top">
              <p class="text-sm">
                **** **** **** {{ paymentMethod.card.last4 }}
              </p>

              <options-menu
                :options="[{ action: 'delete', label: 'Eliminar' }]"
                @delete="
                  paymentMethodToDelete = paymentMethod;
                  openDeleteModal();
                "
              />
            </div>

            <p class="mt-2 text-sm text-content-400">
              {{ paymentMethod.card.exp_month }} /
              {{ paymentMethod.card.exp_year }}
            </p>

            <p class="mt-2 text-sm">
              {{ paymentMethod.card.brand.toUpperCase() }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import PaymentMethodModal from "@/components/modals/PaymentMethodModal";
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
import { mapState } from "vuex";
export default {
  name: "Franchise Detail",

  components: {
    PaymentMethodModal,
  },

  data() {
    return {
      loading: false,
      paymentMethods: null,
      paymentMethodToDelete: null,
      showPaymentMethodModal: false,
    };
  },

  computed: {
    ...mapState({
      user: "user",
    }),
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setSelectedTab", "franchise");

    this.loadPaymentMethods();
  },

  methods: {
    formatDate,

    formatDatetime,

    integerToCurrency,

    async loadPaymentMethods() {
      this.loading = true;

      try {
        this.paymentMethods = (await api.paymentMethods.getAll()).data;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async deletePaymentMethod() {
      this.closeDeleteModal();

      this.loading = true;

      try {
        const response = await api.paymentMethods.delete(
          this.paymentMethodToDelete.id
        );
        this.$store.dispatch("successSnack", response.message);

        this.loadPaymentMethods();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.paymentMethodToDelete = null;
      this.loading = false;
    },
  },
};
</script>